import React from 'react';

interface InlineLoaderProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * Compact inline loader for in-card loading states.
 * Usage: <InlineLoader message="Loading..." size="md" />
 */
export const InlineLoader: React.FC<InlineLoaderProps> = ({
  message,
  size = 'md',
  className = ''
}) => {
  const sizePx = size === 'sm' ? 16 : size === 'lg' ? 32 : 24;
  const borderWidth = size === 'sm' ? 'border' : 'border-2';

  return (
    <div className={`flex flex-col items-center justify-center ${className}`} role="status" aria-live="polite">
      <div
        className={`${borderWidth} ${borderWidth === 'border' ? 'border-gray-300' : 'border-gray-300'} border-t-primary-600 rounded-full animate-spin`}
        style={{ width: sizePx, height: sizePx }}
        aria-label={message || 'Loading'}
      />
      {message && (
        <div className="mt-2 text-xs text-gray-500">{message}</div>
      )}
    </div>
  );
};


